(function () {
    'use strict';

    angular
        .module('crewing')
        .controller('ShowInCrewPortalCtrl', ShowInCrewPortalCtrl);

    function ShowInCrewPortalCtrl($uibModalInstance, modalParams){
        var vm = this;
        vm.model = {
            title: modalParams.title,
            msgCol: modalParams.messages || [],
            allCrew:modalParams.allCrew
        };
        vm.onCloseClick = function () {
            $uibModalInstance.close();
        };

        vm.onYesClick = function(){
            $uibModalInstance.close(vm.model);
        };
    }
}());